export default {
  getFormattedUsers({ users }) {
    return users
  },
}
